import React, { Suspense, useEffect } from 'react';
import { Provider } from 'react-redux';

import Spinner from 'components/Spinner/Spinner';
import './App.scss';
import { store } from 'store';
// import 'mapbox-gl/dist/mapbox-gl.css';
import StepLayout from 'components/Layout/Container/StepLayout';
import { getScriptData } from 'api/common';
import { createScript } from 'utils/createScript';

function App() {
  const fetchScriptData = () => {
    getScriptData().then((res) => {
      const headStart = res.data.data.find(
        (sctipt) =>
          sctipt.key == 'lexus.key.robots' ||
          sctipt.key == 'lexus.key.tag.manager.script.head.start',
      )?.value;
      createScript('headStart', headStart);

      const headEnd = res.data.data.find(
        (sctipt) => sctipt.key == 'lexus.key.tag.manager.script.head.end',
      )?.value;
      createScript('headEnd', headEnd);
      const title = res.data.data.find(
        (sctipt) => sctipt.key == 'lexus.key.tag.title',
      )?.value;
      createScript('headEnd', title);

      const description = res.data.data.find(
        (sctipt) => sctipt.key == 'lexus.key.tag.description',
      )?.value;
      createScript('headEnd', description);

      const bodyStart = res.data.data.find(
        (sctipt) => sctipt.key == 'lexus.key.tag.manager.script.body.start',
      )?.value;
      createScript('bodyStart', bodyStart);

      const bodyEnd = res.data.data.find(
        (sctipt) => sctipt.key == 'lexus.key.tag.manager.script.body.end',
      )?.value;
      createScript('bodyEnd', bodyEnd);
    });
  };

  useEffect(() => {
    fetchScriptData();
  }, []);
  return (
    <Provider store={store}>
      <div className="App">
        <Suspense fallback={<Spinner />}>
          <StepLayout />
        </Suspense>
      </div>
    </Provider>
  );
}

export default App;
